import maplibregl from 'maplibre-gl'
import { cogProtocol } from '@geomatico/maplibre-cog-protocol'

let protocolRegistered = false

/**
 * Регистрирует COG (Cloud Optimized GeoTIFF) протокол для MapLibre GL.
 * Позволяет использовать cog:// URL в источниках карты.
 *
 * @remarks
 * URL формируется как `cog://<HTTP_URL>`, где HTTP_URL — полный путь к COG-файлу.
 *
 * @example
 * Локальный файл:
 * ```
 * HTTP:  /map-data/demo.tif
 * COG:   cog:///map-data/demo.tif
 * ```
 *
 * @example
 * Удалённый файл:
 * ```
 * HTTP:  https://example.com/data.tif
 * COG:   cog://https://example.com/data.tif
 * ```
 *
 * @throws {Error} Если регистрация протокола не удалась
 */
export function registerCOGProtocol(): void {
  if (protocolRegistered) {
    return
  }

  try {
    maplibregl.addProtocol('cog', cogProtocol)
    protocolRegistered = true
  } catch (error) {
    console.error('Failed to register COG protocol:', error)
    throw error
  }
}

/**
 * Проверяет, зарегистрирован ли COG-протокол
 */
export function isCOGProtocolRegistered(): boolean {
  return protocolRegistered
}
